module.exports = __webpack_public_path__ + "static/img/t2.76cfaba9.png";